module.exports = require('./dist/SAlert');


//////////////////
// WEBPACK FOOTER
// ./~/react-s-alert/index.js
// module id = 689
// module chunks = 0